import { createSlice } from "@reduxjs/toolkit";
const initState = {
    address: {
        country: "",
        firstName: "",
        lastName: "",
        street: "",
        state: "",
        city: "",
        apartment: "",
        zip: "",
    },
    cardData: {
        brand: "",
        isPaypal: false,
    },
};
const checkoutBillingSlice = createSlice({
    name: "checkoutBilling",
    initialState: initState,
    reducers: {
        updateBillingInfo(state, action) {
            state.address[action.payload.name] = action.payload.value;
            return state;
        },
        setCardData(state, action) {
            state.cardData = action.payload;
            return state;
        },
    },
});
export const { updateBillingInfo, setCardData } = checkoutBillingSlice.actions;
export default checkoutBillingSlice.reducer;
